// app/javascript/controllers/estimate_items_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    // Define the URL as a Stimulus value, which will be passed from the HTML
    static values = {
        url: String
    }

    // The delete action triggered by a click
    delete(event) {
        // Prevent the default browser action (e.g., following a link)
        event.preventDefault()

        // Get the CSRF token from the page's meta tags
        const csrfToken = document.querySelector("meta[name='csrf-token']").content

        console.log("Deleting item with URL:", this.urlValue)
        // Show a confirmation dialog
        if (confirm("Are you sure?")) {
            // If confirmed, send the DELETE request
            fetch(this.urlValue, {
                method: "DELETE",
                headers: {
                    "X-CSRF-Token": csrfToken,
                    "Accept": "text/vnd.turbo-stream.html" // Ensures Rails responds with Turbo Stream
                }
            })
                .then(response => {
                    if (!response.ok) {
                        console.error("Something went wrong.")
                    }
                    // Turbo will automatically process the response and update the page
                })
        }
    }
}